@if (pills.length || savedQueryActive) {
    <ul class="active-filter-bar">
        @for (pill of pills; track pill.label) {
            <li class="active-filter-bar__item">
                <span
                    class="active-filter-bar__pill"
                    [class.-primary]="pill.origin === 'facet'"
                    [class.-secondary]="pill.origin === 'column'"
                >
                    <span class="active-filter-bar__label" [title]="pill.label">{{ pill.label }}</span>
                    <button
                        type="button"
                        class="active-filter-bar__remove"
                        [attr.aria-label]="'active-filter-bar.remove' | translate"
                        (click)="onRemove(pill)"
                    >
                        <svg sh-icon [name]="'close'" aria-hidden="true"></svg>
                    </button>
                </span>
            </li>
        }
        <li class="active-filter-bar__item active-filter-bar__item--clear">
            <button type="button" class="active-filter-bar__clear" (click)="onClearAll()">
                {{ 'active-filter-bar.clear-all' | translate }}
            </button>
        </li>
    </ul>
}
